module.exports = {
  // 配置显示在浏览器标签的title
  title: '微赞直播',

  // cookie key 值
  COOKIE_KEY: 'zbvz_userid',

  // token key 值
  TOKEN_KEY: 'Authorization',

  // 路由模式
  mode: 'history',

  // 静态资源文件夹名称
  assetsDir: 'm-static',

  // 打包outputDir
  outputDir: process.env.outputDir,

  // cookie 存储天数
  cookieExpires: 1,

  // cdn地址
  cdnPath: 'https://static2.sinsam.com',

  // 路由前缀
  routerPath: '/live/m',

  // debug直播间
  test_zbid: [],

  // 支付参数key
  PAYMENTKEY: 'payment',
  // 健康讲座代理白名单路径企微授权页面地址
  AgentWorkWeiXinWhitePath: [
    '/agent/index',
    '/agent/customerDetail',
    '/agent/storeRecord',
    '/agent/apply',
    '/agent/activateAgent',
  ],
  AgentClearCacheKey: 'agent_clear_cache', // 代理清除缓存
  forceAuthPath: ['/member/index'], // 强制授权页面
  forceAuthKey: 'force_auth',
}
